import React from 'react'

function ItService() {
  return (
    <div>
            <>
      <main className="main">
        {/* Page Title */}
        <div className="page-title dark-background">
          <div className="container position-relative">
            <h1>Service Details</h1>
            <p>Esse dolorum voluptatum ullam est sint nemo et est ipsa porro placeat quibusdam quia assumenda numquam molestias.</p>
            <nav className="breadcrumbs">
              <ol>
                <li><a href="/">Home</a></li>
                <li className="current">Service Details</li>
              </ol>
            </nav>
          </div>
        </div>

        {/* Service Details Section */}
        <section id="service-details" className="service-details section">
          <div className="container">
            <div className="row gy-4">
              <div className="col-lg-4" data-aos="fade-up" data-aos-delay={100}>
                <div className="services-list">
                  <a href="#" className="active">Web Design</a>
                  <a href="#">Software Development</a>
                  <a href="#">Product Management</a>
                  <a href="#">Graphic Design</a>
                  <a href="#">Marketing</a>
                </div>
                <h4>Enim qui eos rerum in delectus</h4>
                <p>Nam voluptatem quasi numquam quas fugiat ex temporibus quo est. Quia aut quam quod facere ut non occaecati ut aut. Nesciunt mollitia illum tempore corrupti sed eum reiciendis. Maxime modi rerum.</p>
              </div>
              <div className="col-lg-8" data-aos="fade-up" data-aos-delay={200}>
                <img src="assets/img/services.jpg" alt="" className="img-fluid services-img" />
                <h3>Temporibus et in vero dicta aut eius lidero plastis trand lined voluptas dolorem ut voluptas</h3>
                <p>
                  Blanditiis voluptate odit ex error ea sed officiis deserunt. Cupiditate non consequatur et doloremque consequuntur...
                </p>
                <ul>
                  <li><i className="bi bi-check-circle" /> <span>Aut eum totam accusantium voluptatem.</span></li>
                  <li><i className="bi bi-check-circle" /> <span>Assumenda et porro nisi nihil nesciunt voluptatibus.</span></li>
                  <li><i className="bi bi-check-circle" /> <span>Ullamco laboris nisi ut aliquip ex ea</span></li>
                </ul>
                <p>
                  Sunt rem odit accusantium omnis perspiciatis officia...
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
    </div>
  )
}

export default ItService
